// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add root color */
:root {
    --color: #181c26;
    --has-text-black:	hsl(0, 0%, 0%);
    --has-text-black-bis:	hsl(0, 0%, 7%);
    --has-text-black-ter:	hsl(0, 0%, 14%);
    --has-text-grey-darker:	hsl(0, 0%, 21%);
    --has-text-grey-dark:	hsl(0, 0%, 29%);
    --has-text-grey:	hsl(0, 0%, 48%);
    --has-text-grey-light:	hsl(0, 0%, 71%);
    --has-text-grey-lighter:	hsl(0, 0%, 86%);
    --has-text-white-ter:	hsl(0, 0%, 96%);
    --has-text-white-bis:	hsl(0, 0%, 98%);
    --has-text-white:	hsl(0, 0%, 100%);
}

/* Set bigger font for TV size screens */
@media screen and (min-width: 2560px) {
    html {
        font-size: 24px;
    }
}

html {
    scroll-snap-type: y mandatory;
    scroll-behavior: smooth;
    background-color: black;
}

body {
    margin: 0;
    padding: 0;
    width: 100vw;
}

section {
    min-height: 600px;
    position: relative;
    scroll-snap-align: start;
    z-index: 1;
}

.hero>.chart {
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0%;
}

.hero>img {
    height: 100vh;
    width: 100vw;
    position: absolute;
    object-fit: scale-down;
    top: 0%;
    left: 0%;
    background-color: rgba(0, 0, 0, 1);
}



#head {
    background-color: color(srgb 0.8962 0.9062 0.9018);
    z-index: 0;
}

#head div {
    z-index: 1;
}

#head img {
    z-index: 0;
}

#head>img {
    background-color: transparent;

    width: 20vmin;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
}

#head>.hero-body>img {
    width: 30vmin;
    min-width: 350px;

    transform: translate(-50%, 0);
    bottom: 15px;
    left: 50%;
    position: absolute;
    border-radius: 50%;

    object-fit: scale-down;
}

#head>.hero-body>.logo-holder {
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 35vw;
}

#head>.hero-body>.logo-holder>img {
    width: 15vmax;
    object-fit: scale-down;
}

#head .title-holder {
    width:65%;
}

#head #mhu-logo {
    width: 10.5vmax;
}

#section-1 .regional-foundsource-filter {
    --right: 30px;
    position: absolute;
    top: 60px;
    right: var(--right);

    width: calc(25vw - var(--right));
    z-index: 1;
}

#section-2 {
    /*
    background: linear-gradient(to bottom, black 0%, black 50%, #1F2632 50%, #1F2632 100%);
    */
    position: relative;
    background-color: black;
    height: 100vh;
    padding-bottom: 25px;
}

#section-2>.background {
    position: absolute;
    z-index: 0;
    height: 100%;
    width: 100%;


    --top: radial-gradient(calc(5px + 60px) at 50% calc(100% + 5px),#0000 98%,#000);
    -webkit-mask: var(--top);
            mask: var(--top);
}

#section-2 .top {
    height: 50%;
    width: 100%;
}

#section-2 .bottom {
    height: 65%;
    width: 100%;

    background: radial-gradient(ellipse 100% 100% at bottom 0% left 50%, #4a7081 0%, #10171e 100%);

    --mask:
        radial-gradient(117.15px at 50% 165.00px, #000 99%, #0000 101%) calc(50% - 150px) 0/300px 100%,
        radial-gradient(117.15px at 50% -90px, #0000 99%, #000 101%) 50% 75px/300px 100% repeat-x;
    -webkit-mask: var(--mask);
    mask: var(--mask);

    z-index: 2;

}

#section-2>.level {
    z-index: 1;

    padding-left: 20px;
    padding-right: 20px;
}

#section-2>.level>.level-item:not(.full-width) {
    max-width: 20%;
}

#section-2>.level>.level-item.full-width {
    flex-shrink: 1;
}

#section-2 .level-item.full-width>.columns {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 35vh;
}

#section-2 .level-item.full-width>.columns::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

#institutional-section{
    width: 100%;
}

#institutional-section .gradient-background {
    --bottom: 
    linear-gradient(#000 0 0) bottom/100% calc(100% - 60px) no-repeat,
    radial-gradient(farthest-side,#000 98%,#0000) top/120px 120px no-repeat;
    -webkit-mask: var(--bottom);
            mask: var(--bottom);
    margin-top: -55px;

    z-index:1;
    position: absolute; 

    width: 100vw;
    min-height: 250vh;

    background: rgb(65,44,59);
    background: radial-gradient(circle, rgba(65,44,59,1) 0%, rgb(22 23 34) 100%);
}

#institutional-section .gradient-background.no-clutch {
    --bottom: none;
    margin-top: 0;
}

/*
#section-3 .chart {
    -moz-backdrop-filter: brightness(90%) blur(40px);
    -webkit-backdrop-filter: brightness(90%) blur(40px);
    backdrop-filter: brightness(90%) blur(40px);
}
*/
#section-3 {
    display: flex;
    flex-direction: row;
    justify-content: start;
    width: 100%;
}

#chart-container{
    height: 100vh;
    width: 69%;
}

#chart-container .chart {
    height: 100%;
    width: 100%;
}

#chart-container {
    position: relative;
}

#section-3 #vaccine-name-holder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
    width: 10vmin;
    height: 10vmin;
    border-radius: 50%;
    opacity: 1;
    transition: all 0.5s ease-in-out;
}

#section-3 #vaccine-name-holder span {
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.84rem;
    font-weight: bold;
    color: white;
    text-align: center;
}

#section-3 #vaccine-name-holder.hidden {
    top: 75%;
    opacity: 0;
}

#section-3 #search-container {
    width: 25%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: start;
}

#section-3 #search-container .message.search-result {
    display: none;
    border-radius: 10px;
}
#section-3 #search-container .message.search-result .message-header {
    border-radius: 10px 10px 0 0;
    background: none;
    color: inherit;
}
#section-3 #search-contaner .message.search-result .message-header .success {
    color: #11998e;
}
#section-3 #search-contaner .message.search-result .message-header .failure {
    color: #84442d;
}
#section-3 #search-contaner .message.search-result .message-header .warning {
    color: #c89917;
}

#section-3 #search-container .form__group {
    position: relative;
    padding: 15px 0 0;
    margin-top: 10px;
    width: 100%;
}

#section-3 #search-container .form__field {
    font-family: inherit;
    width: 100%;
    border: 0;
    border-bottom: 2px solid #9b9b9b;
    outline: 0;
    font-size: 1.3rem;
    color: #fff;
    padding: 7px 0;
    background: transparent;
    transition: border-color 0.2s;
}
#section-3 #search-container .form__field::placeholder {
    color: transparent;
}
#section-3 #search-container .form__field:placeholder-shown ~ .form__label {
    font-size: 1.3rem;
    cursor: text;
    top: 20px;
}

#section-3 #search-container .form__label {
    position: absolute;
    top: 0;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #9b9b9b;
}

#section-3 #search-container .form__field:focus {
    padding-bottom: 6px;
    font-weight: 700;
    border-width: 3px;
    border-image: linear-gradient(to right, #11998e, #38ef7d);
    border-image-slice: 1;
}
#section-3 #search-container .form__field:focus ~ .form__label {
    position: absolute;
    top: 0;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #11998e;
    font-weight: 700;
}

/* reset input */
#section-3 #search-container .form__field:required, .form__field:invalid {
    box-shadow: none;
}

#section-4>.right {
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
}

#section-4 .dropdown .button {
    width: 225px;
    height: 50px;

    font-size: 1.08rem;
    font-family: monospace;

    color: hsl(0, 0%, 4%);
    background: linear-gradient(145deg, rgb(173, 203, 255), rgb(136, 255, 202));
    border: 1px solid black;
}
#section-4 .dropdown .dropdown-content {
    text-align: center;
    background-color: hsl(0, 0%, 96%);
    cursor: pointer;
}
#section-4 .dropdown .dropdown-item {
    color: hsl(0, 0%, 4%);
    width: 225px;
    font-family: monospace;
    font-size: 0.9rem;
}

#leftovers-section {
    background: radial-gradient(ellipse 70% 50% at top 0% right 50%, #25383a 0%, #1d2528 100%);
    z-index: 3;
    position: relative;
    padding-right:10px;
}

#leftovers-section .box {
    background: linear-gradient(180deg, rgb(20 28 32) 0%, rgb(33 44 48) 100%);
}

#leftovers-section .box.map {
    background: radial-gradient(circle at top 0% right 50%, rgb(45 55 60) 0%, rgb(11 19 23) 100%);
}

#section-5 {
    z-index: 2;
    max-height: 100vh;
}

#section-5 .two-section-container {
    height: calc(100vh + 45px);
    z-index: 2;
    pointer-events: none;
}

#section-5 .usage-includer {
    z-index: 3;
}

#section-5 .region-selector {
    z-index: 3;
}

#section-5 .dropdown .button {
    width: 14rem;
    padding: 0.8rem 0;

    font-size: 1.05rem;
    font-family: monospace;

    border-top-right-radius: 0;
    border-top-left-radius: 0;

    color: hsl(0, 0%, 96%);
    background: rgb(146, 61, 61);
    border: 1px solid transparent;
}
#section-5 .dropdown .dropdown-content {
    text-align: center;
    background-color: hsl(0, 0%, 96%);
    cursor: pointer;
}
#section-5 .dropdown .dropdown-item {
    color: hsl(0, 0%, 4%);
    width: 14rem;
    font-family: monospace;
    font-size: 0.9rem;
}

#section-6 .avoid-dropdown {
    margin-top: 2.65rem;
}

#section-6 .column.red>.column {
    padding: 15px 0;
}

#section-6 .red {
    background: rgb(146, 61, 61);
    /* color: hsl(0 0% 96% / 1); */
}

#section-6 .red p {
    color: hsl(0, 0%, 96%);
}

#section-6 .report-layer {
    min-height: 15vh;
    margin-top: 2rem;
}

#section-6 .report-layer div .column p.title{
    margin-bottom: 10px;
}

#section-6 .chart {
    height: 100%;
    width: 100%;
}

#section-6 .expandable {
    transition-property: width;
    transition-duration: 0.5s;
}

#section-6 .triple-chart {
    overflow-x: hidden;
    background: radial-gradient(circle at top 0% right 50%, rgb(45 55 60) 0%, rgb(11 19 23) 100%);
}

#section-6 .triple-chart::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

#section-6 .triple-chart .columns {
    height: 100%;
    max-height: 43vh;
}

#section-6 .triple-chart .columns .column {
    flex-shrink: 25;
    flex-basis: 80%;
    overflow: hidden;

    position: relative;
    transition: all 0.5s ease-in-out;
}

#section-6 .triple-chart .columns .column.active {
    flex-shrink: 1;
}

#section-6 .triple-chart .columns .column:not(.active) {
    filter:brightness(0.3);
}

#section-6 .triple-chart .columns .column p {
    position: absolute;
    text-align: center;
    left: 20px;
    top: 45%;
    transform: rotate(90deg) translateX(-50%);
    font-size: 28px;
    
    width: 300px;

    transform-origin: left bottom;
    transition: all 0.5s ease-in-out;
}

#section-6 .triple-chart .columns .column.active p {
    text-align: left;
    left: 25px;
    top: 10px;
    font-size: 16.5px;
    transform: rotate(0deg);
}

#section-6 .triple-chart .columns .column .chart{
    width: calc(0.75 * var(--grandparent-width));
}

#coverageChartContainer {
    height: 100%;
    width: 100%;
}

#vaccineDropdown {
    z-index: 1;
    position: absolute;
    top: 70px;
    right: 40px;
}

#vaccineDropdown .dropdown__container {
    position: relative;
    width: 270px;
    filter: url(#goo);
}

#vaccineDropdown .dropdown__face, #vaccineDropdown .dropdown__items {
background-color: #fff;
padding: 20px;
border-radius: 25px;
}
#vaccineDropdown .dropdown__face {
display: block;
position: relative;
}
#vaccineDropdown .dropdown__items {
margin: 0;
position: absolute;
right: 0;
top: 50%;
width: 100%;
list-style: none;
list-style-type: none;
display: flex;
flex-wrap: wrap;
justify-content: space-between;
visibility: hidden;
z-index: -1;
opacity: 0;
transition: all 0.4s cubic-bezier(0.93, 0.88, 0.1, 0.8);
}
#vaccineDropdown .dropdown__items::before {
content: "";
background-color: #fff;
position: absolute;
bottom: 100%;
right: 20%;
height: 40px;
width: 20px;
}
#vaccineDropdown .dropdown__arrow {
border-bottom: 2px solid #000;
border-right: 2px solid #000;
position: absolute;
top: 50%;
right: 30px;
width: 10px;
height: 10px;
transform: rotate(45deg) translateY(-50%);
transform-origin: right;
}
#vaccineDropdown .dropdown__container input {
display: none;
}
#vaccineDropdown .dropdown__container input:checked ~ .dropdown__items {
top: calc(100% + 25px);
visibility: visible;
opacity: 1;
}

#vaccineDropdown * {
    box-sizing: border-box;
}

#vaccineDropdown svg {
    display: none;
}

.checkbox-wrapper {
    display: flex;
    align-items: center;
    margin-left: 10px
}

.checkbox-wrapper>p {
    margin-left: 5px;
    font-family: monospace;
    font-size: 1rem;
    color: hsl(0, 0%, 4%);
    cursor: pointer;
}

.checkbox-wrapper *,
.checkbox-wrapper *::before,
.checkbox-wrapper *::after {
    box-sizing: border-box;
}

.checkbox-wrapper .plus-minus {
    --primary: #1d2528;
    --secondary: #FAFBFF;
    --duration: .5s;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    mask-image: radial-gradient(white, black);;
    outline: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transform-style: preserve-3d;
    perspective: 240px;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    border: 4px solid var(--primary);
    background-size: 300% 300%;
    transition: transform 0.3s;
    transform: scale(var(--scale, 1)) translateZ(0);
    -webkit-animation: var(--name, unchecked) var(--duration) ease forwards;
            animation: var(--name, unchecked) var(--duration) ease forwards;
    margin: 0;
}
.checkbox-wrapper .plus-minus::before,
.checkbox-wrapper .plus-minus::after {
    content: "";
    position: absolute;
    width: 16px;
    height: var(--height, 16px);
    left: 6px;
    top: var(--top, 6px);
    background: var(--background, var(--primary));
    -webkit-animation: var(--name-icon-b, var(--name-icon, unchecked-icon)) var(--duration) ease forwards;
            animation: var(--name-icon-b, var(--name-icon, unchecked-icon)) var(--duration) ease forwards;
}
.checkbox-wrapper .plus-minus::before {
    -webkit-clip-path: polygon(0 6px, 6px 6px, 6px 0, 10px 0, 10px 6px, 16px 6px, 16px 10px, 10px 10px, 10px 16px, 6px 16px, 6px 10px, 0 10px);
            clip-path: polygon(0 6px, 6px 6px, 6px 0, 10px 0, 10px 6px, 16px 6px, 16px 10px, 10px 10px, 10px 16px, 6px 16px, 6px 10px, 0 10px);
}
.checkbox-wrapper .plus-minus::after {
    --height: 4px;
    --top: 12px;
    --background: var(--secondary);
    --name-icon-b: var(--name-icon-a, checked-icon);
}
.checkbox-wrapper .plus-minus:active {
    --scale: .95;
}
.checkbox-wrapper .plus-minus:checked {
    --name: checked;
    --name-icon-b: checked-icon;
    --name-icon-a: unchecked-icon;
}

@-webkit-keyframes checked-icon {
    from {
    transform: translateZ(12px);
    }
    to {
    transform: translateX(16px) rotateY(90deg) translateZ(12px);
    }
}
@keyframes checked-icon {
    from {
    transform: translateZ(12px);
    }
    to {
    transform: translateX(16px) rotateY(90deg) translateZ(12px);
    }
}

@-webkit-keyframes unchecked-icon {
    from {
    transform: translateX(-16px) rotateY(-90deg) translateZ(12px);
    }
    to {
    transform: translateZ(12px);
    }
}
@keyframes unchecked-icon {
    from {
    transform: translateX(-16px) rotateY(-90deg) translateZ(12px);
    }
    to {
    transform: translateZ(12px);
    }
}

@-webkit-keyframes checked {
    from {
    background-image: radial-gradient(ellipse at center, var(--primary) 0%, var(--primary) 25%, var(--secondary) 25.1%, var(--secondary) 100%);
    background-position: 100% 50%;
    }
    to {
    background-image: radial-gradient(ellipse at center, var(--primary) 0%, var(--primary) 25%, var(--secondary) 25.1%, var(--secondary) 100%);
    background-position: 50% 50%;
    }
}
@keyframes checked {
    from {
    background-image: radial-gradient(ellipse at center, var(--primary) 0%, var(--primary) 25%, var(--secondary) 25.1%, var(--secondary) 100%);
    background-position: 100% 50%;
    }
    to {
    background-image: radial-gradient(ellipse at center, var(--primary) 0%, var(--primary) 25%, var(--secondary) 25.1%, var(--secondary) 100%);
    background-position: 50% 50%;
    }
}

@-webkit-keyframes unchecked {
    from {
    background-image: radial-gradient(ellipse at center, var(--secondary) 0%, var(--secondary) 25%, var(--primary) 25.1%, var(--primary) 100%);
    background-position: 100% 50%;
    }
    to {
    background-image: radial-gradient(ellipse at center, var(--secondary) 0%, var(--secondary) 25%, var(--primary) 25.1%, var(--primary) 100%);
    background-position: 50% 50%;
    }
}
@keyframes unchecked {
    from {
    background-image: radial-gradient(ellipse at center, var(--secondary) 0%, var(--secondary) 25%, var(--primary) 25.1%, var(--primary) 100%);
    background-position: 100% 50%;
    }
    to {
    background-image: radial-gradient(ellipse at center, var(--secondary) 0%, var(--secondary) 25%, var(--primary) 25.1%, var(--primary) 100%);
    background-position: 50% 50%;
    }
}

.black-background {
    background-color: black !important;
}

.y-scrollable {
    overflow-y: auto;
}

.height-100 {
    height: 100%;
}

.huge-font {
    font-size: 5rem;
}

.pos-tr {
    position: absolute;
    top: 0;
    right: 0;
}

.pos-tc {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}        

.pos-tl {
    position: absolute;
    top: 0;
    left: 0;
}

.pos-br {
    position: absolute;
    bottom: 0;
    right: 0;
}

.pos-bl {
    position: absolute;
    bottom: 0;
    left: 0;
}

.sticky {
    position: sticky;
    top: 0;
    pointer-events: all;
}

.no-padding {
    padding: 0 !important;
}

.is-relative {
    position: relative !important;
}

.is-hidden {
    display: none !important;
}

.is-clickable {
    cursor: pointer;
}

.is-bold {
    font-weight: bold;
}

.height-capped {
    max-height: 25vh;
    overflow-y: auto;
}

.height-capped::-webkit-scrollbar {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,gCAAgC;IAChC,oCAAoC;IACpC,qCAAqC;IACrC,uCAAuC;IACvC,qCAAqC;IACrC,gCAAgC;IAChC,sCAAsC;IACtC,wCAAwC;IACxC,qCAAqC;IACrC,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA,wCAAwC;AACxC;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,OAAO;IACP,QAAQ;IACR,kCAAkC;AACtC;;;;AAIA;IACI,kDAAkD;IAClD,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;;IAE7B,aAAa;IACb,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gBAAgB;;IAEhB,6BAA6B;IAC7B,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,kBAAkB;;IAElB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,mBAAmB;;IAEnB,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI;;KAEC;IACD,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;;;IAGX,+EAA+E;IAC/E,wBAAwB;YAChB,gBAAgB;AAC5B;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;;IAEX,8FAA8F;;IAE9F;;iGAE6F;IAC7F,yBAAyB;IACzB,iBAAiB;;IAEjB,UAAU;;AAEd;;AAEA;IACI,UAAU;;IAEV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;;2EAEuE;IACvE,2BAA2B;YACnB,mBAAmB;IAC3B,iBAAiB;;IAEjB,SAAS;IACT,kBAAkB;;IAElB,YAAY;IACZ,iBAAiB;;IAEjB,yBAAyB;IACzB,4EAA4E;AAChF;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;;;;;;CAMC;AACD;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yDAAyD;IACzD,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,YAAY;;IAEZ,kBAAkB;IAClB,sBAAsB;;IAEtB,qBAAqB;IACrB,2EAA2E;IAC3E,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,0FAA0F;IAC1F,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;IACI,6FAA6F;AACjG;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;;IAEjB,kBAAkB;IAClB,sBAAsB;;IAEtB,0BAA0B;IAC1B,yBAAyB;;IAEzB,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,6FAA6F;AACjG;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;;IAEhB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,yCAAyC;IACzC,eAAe;;IAEf,YAAY;;IAEZ,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;AACA,sBAAsB;AACtB,aAAa;AACb,mBAAmB;AACnB;AACA;AACA,cAAc;AACd,kBAAkB;AAClB;AACA;AACA,SAAS;AACT,kBAAkB;AAClB,QAAQ;AACR,QAAQ;AACR,WAAW;AACX,gBAAgB;AAChB,qBAAqB;AACrB,aAAa;AACb,eAAe;AACf,8BAA8B;AAC9B,kBAAkB;AAClB,WAAW;AACX,UAAU;AACV,uDAAuD;AACvD;AACA;AACA,WAAW;AACX,sBAAsB;AACtB,kBAAkB;AAClB,YAAY;AACZ,UAAU;AACV,YAAY;AACZ,WAAW;AACX;AACA;AACA,6BAA6B;AAC7B,4BAA4B;AAC5B,kBAAkB;AAClB,QAAQ;AACR,WAAW;AACX,WAAW;AACX,YAAY;AACZ,yCAAyC;AACzC,uBAAuB;AACvB;AACA;AACA,aAAa;AACb;AACA;AACA,sBAAsB;AACtB,mBAAmB;AACnB,UAAU;AACV;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,wCAAwC;IACxC,yDAAyD;IACzD,yCAAyC;IACzC,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,0BAA0B;IAC1B,0BAA0B;IAC1B,+CAA+C;IAC/C,uEAAuE;YAC/D,+DAA+D;IACvE,SAAS;AACb;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,oBAAoB;IACpB,6CAA6C;IAC7C,qGAAqG;YAC7F,6FAA6F;AACzG;AACA;IACI,0IAA0I;YAClI,kIAAkI;AAC9I;AACA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,+CAA+C;AACnD;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI;IACA,2BAA2B;IAC3B;IACA;IACA,2DAA2D;IAC3D;AACJ;AACA;IACI;IACA,2BAA2B;IAC3B;IACA;IACA,2DAA2D;IAC3D;AACJ;;AAEA;IACI;IACA,6DAA6D;IAC7D;IACA;IACA,2BAA2B;IAC3B;AACJ;AACA;IACI;IACA,6DAA6D;IAC7D;IACA;IACA,2BAA2B;IAC3B;AACJ;;AAEA;IACI;IACA,0IAA0I;IAC1I,6BAA6B;IAC7B;IACA;IACA,0IAA0I;IAC1I,4BAA4B;IAC5B;AACJ;AACA;IACI;IACA,0IAA0I;IAC1I,6BAA6B;IAC7B;IACA;IACA,0IAA0I;IAC1I,4BAA4B;IAC5B;AACJ;;AAEA;IACI;IACA,0IAA0I;IAC1I,6BAA6B;IAC7B;IACA;IACA,0IAA0I;IAC1I,4BAA4B;IAC5B;AACJ;AACA;IACI;IACA,0IAA0I;IAC1I,6BAA6B;IAC7B;IACA;IACA,0IAA0I;IAC1I,4BAA4B;IAC5B;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/* Add root color */\n:root {\n    --color: #181c26;\n    --has-text-black:\thsl(0, 0%, 0%);\n    --has-text-black-bis:\thsl(0, 0%, 7%);\n    --has-text-black-ter:\thsl(0, 0%, 14%);\n    --has-text-grey-darker:\thsl(0, 0%, 21%);\n    --has-text-grey-dark:\thsl(0, 0%, 29%);\n    --has-text-grey:\thsl(0, 0%, 48%);\n    --has-text-grey-light:\thsl(0, 0%, 71%);\n    --has-text-grey-lighter:\thsl(0, 0%, 86%);\n    --has-text-white-ter:\thsl(0, 0%, 96%);\n    --has-text-white-bis:\thsl(0, 0%, 98%);\n    --has-text-white:\thsl(0, 0%, 100%);\n}\n\n/* Set bigger font for TV size screens */\n@media screen and (min-width: 2560px) {\n    html {\n        font-size: 24px;\n    }\n}\n\nhtml {\n    scroll-snap-type: y mandatory;\n    scroll-behavior: smooth;\n    background-color: black;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    width: 100vw;\n}\n\nsection {\n    min-height: 600px;\n    position: relative;\n    scroll-snap-align: start;\n    z-index: 1;\n}\n\n.hero>.chart {\n    height: 100vh;\n    width: 100vw;\n    position: absolute;\n    top: 0%;\n}\n\n.hero>img {\n    height: 100vh;\n    width: 100vw;\n    position: absolute;\n    object-fit: scale-down;\n    top: 0%;\n    left: 0%;\n    background-color: rgba(0, 0, 0, 1);\n}\n\n\n\n#head {\n    background-color: color(srgb 0.8962 0.9062 0.9018);\n    z-index: 0;\n}\n\n#head div {\n    z-index: 1;\n}\n\n#head img {\n    z-index: 0;\n}\n\n#head>img {\n    background-color: transparent;\n\n    width: 20vmin;\n    top: 10%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n#head>.hero-body>img {\n    width: 30vmin;\n    min-width: 350px;\n\n    transform: translate(-50%, 0);\n    bottom: 15px;\n    left: 50%;\n    position: absolute;\n    border-radius: 50%;\n\n    object-fit: scale-down;\n}\n\n#head>.hero-body>.logo-holder {\n    position: absolute;\n    top: 15px;\n    left: 50%;\n    transform: translate(-50%, 0);\n    width: 35vw;\n}\n\n#head>.hero-body>.logo-holder>img {\n    width: 15vmax;\n    object-fit: scale-down;\n}\n\n#head .title-holder {\n    width:65%;\n}\n\n#head #mhu-logo {\n    width: 10.5vmax;\n}\n\n#section-1 .regional-foundsource-filter {\n    --right: 30px;\n    position: absolute;\n    top: 60px;\n    right: var(--right);\n\n    width: calc(25vw - var(--right));\n    z-index: 1;\n}\n\n#section-2 {\n    /*\n    background: linear-gradient(to bottom, black 0%, black 50%, #1F2632 50%, #1F2632 100%);\n    */\n    position: relative;\n    background-color: black;\n    height: 100vh;\n    padding-bottom: 25px;\n}\n\n#section-2>.background {\n    position: absolute;\n    z-index: 0;\n    height: 100%;\n    width: 100%;\n\n\n    --top: radial-gradient(calc(5px + 60px) at 50% calc(100% + 5px),#0000 98%,#000);\n    -webkit-mask: var(--top);\n            mask: var(--top);\n}\n\n#section-2 .top {\n    height: 50%;\n    width: 100%;\n}\n\n#section-2 .bottom {\n    height: 65%;\n    width: 100%;\n\n    background: radial-gradient(ellipse 100% 100% at bottom 0% left 50%, #4a7081 0%, #10171e 100%);\n\n    --mask:\n        radial-gradient(117.15px at 50% 165.00px, #000 99%, #0000 101%) calc(50% - 150px) 0/300px 100%,\n        radial-gradient(117.15px at 50% -90px, #0000 99%, #000 101%) 50% 75px/300px 100% repeat-x;\n    -webkit-mask: var(--mask);\n    mask: var(--mask);\n\n    z-index: 2;\n\n}\n\n#section-2>.level {\n    z-index: 1;\n\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n#section-2>.level>.level-item:not(.full-width) {\n    max-width: 20%;\n}\n\n#section-2>.level>.level-item.full-width {\n    flex-shrink: 1;\n}\n\n#section-2 .level-item.full-width>.columns {\n    overflow-x: hidden;\n    overflow-y: auto;\n    max-height: 35vh;\n}\n\n#section-2 .level-item.full-width>.columns::-webkit-scrollbar {\n    width: 0px;\n    background: transparent;\n}\n\n#institutional-section{\n    width: 100%;\n}\n\n#institutional-section .gradient-background {\n    --bottom: \n    linear-gradient(#000 0 0) bottom/100% calc(100% - 60px) no-repeat,\n    radial-gradient(farthest-side,#000 98%,#0000) top/120px 120px no-repeat;\n    -webkit-mask: var(--bottom);\n            mask: var(--bottom);\n    margin-top: -55px;\n\n    z-index:1;\n    position: absolute; \n\n    width: 100vw;\n    min-height: 250vh;\n\n    background: rgb(65,44,59);\n    background: radial-gradient(circle, rgba(65,44,59,1) 0%, rgb(22 23 34) 100%);\n}\n\n#institutional-section .gradient-background.no-clutch {\n    --bottom: none;\n    margin-top: 0;\n}\n\n/*\n#section-3 .chart {\n    -moz-backdrop-filter: brightness(90%) blur(40px);\n    -webkit-backdrop-filter: brightness(90%) blur(40px);\n    backdrop-filter: brightness(90%) blur(40px);\n}\n*/\n#section-3 {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    width: 100%;\n}\n\n#chart-container{\n    height: 100vh;\n    width: 69%;\n}\n\n#chart-container .chart {\n    height: 100%;\n    width: 100%;\n}\n\n#chart-container {\n    position: relative;\n}\n\n#section-3 #vaccine-name-holder {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 0;\n    width: 10vmin;\n    height: 10vmin;\n    border-radius: 50%;\n    opacity: 1;\n    transition: all 0.5s ease-in-out;\n}\n\n#section-3 #vaccine-name-holder span {\n    position: absolute;\n    top: 80%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 0.84rem;\n    font-weight: bold;\n    color: white;\n    text-align: center;\n}\n\n#section-3 #vaccine-name-holder.hidden {\n    top: 75%;\n    opacity: 0;\n}\n\n#section-3 #search-container {\n    width: 25%;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: start;\n}\n\n#section-3 #search-container .message.search-result {\n    display: none;\n    border-radius: 10px;\n}\n#section-3 #search-container .message.search-result .message-header {\n    border-radius: 10px 10px 0 0;\n    background: none;\n    color: inherit;\n}\n#section-3 #search-contaner .message.search-result .message-header .success {\n    color: #11998e;\n}\n#section-3 #search-contaner .message.search-result .message-header .failure {\n    color: #84442d;\n}\n#section-3 #search-contaner .message.search-result .message-header .warning {\n    color: #c89917;\n}\n\n#section-3 #search-container .form__group {\n    position: relative;\n    padding: 15px 0 0;\n    margin-top: 10px;\n    width: 100%;\n}\n\n#section-3 #search-container .form__field {\n    font-family: inherit;\n    width: 100%;\n    border: 0;\n    border-bottom: 2px solid #9b9b9b;\n    outline: 0;\n    font-size: 1.3rem;\n    color: #fff;\n    padding: 7px 0;\n    background: transparent;\n    transition: border-color 0.2s;\n}\n#section-3 #search-container .form__field::placeholder {\n    color: transparent;\n}\n#section-3 #search-container .form__field:placeholder-shown ~ .form__label {\n    font-size: 1.3rem;\n    cursor: text;\n    top: 20px;\n}\n\n#section-3 #search-container .form__label {\n    position: absolute;\n    top: 0;\n    display: block;\n    transition: 0.2s;\n    font-size: 1rem;\n    color: #9b9b9b;\n}\n\n#section-3 #search-container .form__field:focus {\n    padding-bottom: 6px;\n    font-weight: 700;\n    border-width: 3px;\n    border-image: linear-gradient(to right, #11998e, #38ef7d);\n    border-image-slice: 1;\n}\n#section-3 #search-container .form__field:focus ~ .form__label {\n    position: absolute;\n    top: 0;\n    display: block;\n    transition: 0.2s;\n    font-size: 1rem;\n    color: #11998e;\n    font-weight: 700;\n}\n\n/* reset input */\n#section-3 #search-container .form__field:required, .form__field:invalid {\n    box-shadow: none;\n}\n\n#section-4>.right {\n    border-top-left-radius: 25px;\n    border-bottom-left-radius: 25px;\n}\n\n#section-4 .dropdown .button {\n    width: 225px;\n    height: 50px;\n\n    font-size: 1.08rem;\n    font-family: monospace;\n\n    color: hsl(0, 0%, 4%);\n    background: linear-gradient(145deg, rgb(173, 203, 255), rgb(136, 255, 202));\n    border: 1px solid black;\n}\n#section-4 .dropdown .dropdown-content {\n    text-align: center;\n    background-color: hsl(0, 0%, 96%);\n    cursor: pointer;\n}\n#section-4 .dropdown .dropdown-item {\n    color: hsl(0, 0%, 4%);\n    width: 225px;\n    font-family: monospace;\n    font-size: 0.9rem;\n}\n\n#leftovers-section {\n    background: radial-gradient(ellipse 70% 50% at top 0% right 50%, #25383a 0%, #1d2528 100%);\n    z-index: 3;\n    position: relative;\n    padding-right:10px;\n}\n\n#leftovers-section .box {\n    background: linear-gradient(180deg, rgb(20 28 32) 0%, rgb(33 44 48) 100%);\n}\n\n#leftovers-section .box.map {\n    background: radial-gradient(circle at top 0% right 50%, rgb(45 55 60) 0%, rgb(11 19 23) 100%);\n}\n\n#section-5 {\n    z-index: 2;\n    max-height: 100vh;\n}\n\n#section-5 .two-section-container {\n    height: calc(100vh + 45px);\n    z-index: 2;\n    pointer-events: none;\n}\n\n#section-5 .usage-includer {\n    z-index: 3;\n}\n\n#section-5 .region-selector {\n    z-index: 3;\n}\n\n#section-5 .dropdown .button {\n    width: 14rem;\n    padding: 0.8rem 0;\n\n    font-size: 1.05rem;\n    font-family: monospace;\n\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n\n    color: hsl(0, 0%, 96%);\n    background: rgb(146, 61, 61);\n    border: 1px solid transparent;\n}\n#section-5 .dropdown .dropdown-content {\n    text-align: center;\n    background-color: hsl(0, 0%, 96%);\n    cursor: pointer;\n}\n#section-5 .dropdown .dropdown-item {\n    color: hsl(0, 0%, 4%);\n    width: 14rem;\n    font-family: monospace;\n    font-size: 0.9rem;\n}\n\n#section-6 .avoid-dropdown {\n    margin-top: 2.65rem;\n}\n\n#section-6 .column.red>.column {\n    padding: 15px 0;\n}\n\n#section-6 .red {\n    background: rgb(146, 61, 61);\n    /* color: hsl(0 0% 96% / 1); */\n}\n\n#section-6 .red p {\n    color: hsl(0, 0%, 96%);\n}\n\n#section-6 .report-layer {\n    min-height: 15vh;\n    margin-top: 2rem;\n}\n\n#section-6 .report-layer div .column p.title{\n    margin-bottom: 10px;\n}\n\n#section-6 .chart {\n    height: 100%;\n    width: 100%;\n}\n\n#section-6 .expandable {\n    transition-property: width;\n    transition-duration: 0.5s;\n}\n\n#section-6 .triple-chart {\n    overflow-x: hidden;\n    background: radial-gradient(circle at top 0% right 50%, rgb(45 55 60) 0%, rgb(11 19 23) 100%);\n}\n\n#section-6 .triple-chart::-webkit-scrollbar {\n    width: 0px;\n    background: transparent;\n}\n\n#section-6 .triple-chart .columns {\n    height: 100%;\n    max-height: 43vh;\n}\n\n#section-6 .triple-chart .columns .column {\n    flex-shrink: 25;\n    flex-basis: 80%;\n    overflow: hidden;\n\n    position: relative;\n    transition: all 0.5s ease-in-out;\n}\n\n#section-6 .triple-chart .columns .column.active {\n    flex-shrink: 1;\n}\n\n#section-6 .triple-chart .columns .column:not(.active) {\n    filter:brightness(0.3);\n}\n\n#section-6 .triple-chart .columns .column p {\n    position: absolute;\n    text-align: center;\n    left: 20px;\n    top: 45%;\n    transform: rotate(90deg) translateX(-50%);\n    font-size: 28px;\n    \n    width: 300px;\n\n    transform-origin: left bottom;\n    transition: all 0.5s ease-in-out;\n}\n\n#section-6 .triple-chart .columns .column.active p {\n    text-align: left;\n    left: 25px;\n    top: 10px;\n    font-size: 16.5px;\n    transform: rotate(0deg);\n}\n\n#section-6 .triple-chart .columns .column .chart{\n    width: calc(0.75 * var(--grandparent-width));\n}\n\n#coverageChartContainer {\n    height: 100%;\n    width: 100%;\n}\n\n#vaccineDropdown {\n    z-index: 1;\n    position: absolute;\n    top: 70px;\n    right: 40px;\n}\n\n#vaccineDropdown .dropdown__container {\n    position: relative;\n    width: 270px;\n    filter: url(#goo);\n}\n\n#vaccineDropdown .dropdown__face, #vaccineDropdown .dropdown__items {\nbackground-color: #fff;\npadding: 20px;\nborder-radius: 25px;\n}\n#vaccineDropdown .dropdown__face {\ndisplay: block;\nposition: relative;\n}\n#vaccineDropdown .dropdown__items {\nmargin: 0;\nposition: absolute;\nright: 0;\ntop: 50%;\nwidth: 100%;\nlist-style: none;\nlist-style-type: none;\ndisplay: flex;\nflex-wrap: wrap;\njustify-content: space-between;\nvisibility: hidden;\nz-index: -1;\nopacity: 0;\ntransition: all 0.4s cubic-bezier(0.93, 0.88, 0.1, 0.8);\n}\n#vaccineDropdown .dropdown__items::before {\ncontent: \"\";\nbackground-color: #fff;\nposition: absolute;\nbottom: 100%;\nright: 20%;\nheight: 40px;\nwidth: 20px;\n}\n#vaccineDropdown .dropdown__arrow {\nborder-bottom: 2px solid #000;\nborder-right: 2px solid #000;\nposition: absolute;\ntop: 50%;\nright: 30px;\nwidth: 10px;\nheight: 10px;\ntransform: rotate(45deg) translateY(-50%);\ntransform-origin: right;\n}\n#vaccineDropdown .dropdown__container input {\ndisplay: none;\n}\n#vaccineDropdown .dropdown__container input:checked ~ .dropdown__items {\ntop: calc(100% + 25px);\nvisibility: visible;\nopacity: 1;\n}\n\n#vaccineDropdown * {\n    box-sizing: border-box;\n}\n\n#vaccineDropdown svg {\n    display: none;\n}\n\n.checkbox-wrapper {\n    display: flex;\n    align-items: center;\n    margin-left: 10px\n}\n\n.checkbox-wrapper>p {\n    margin-left: 5px;\n    font-family: monospace;\n    font-size: 1rem;\n    color: hsl(0, 0%, 4%);\n    cursor: pointer;\n}\n\n.checkbox-wrapper *,\n.checkbox-wrapper *::before,\n.checkbox-wrapper *::after {\n    box-sizing: border-box;\n}\n\n.checkbox-wrapper .plus-minus {\n    --primary: #1d2528;\n    --secondary: #FAFBFF;\n    --duration: .5s;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-mask-image: -webkit-radial-gradient(white, black);\n    mask-image: radial-gradient(white, black);;\n    outline: none;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    transform-style: preserve-3d;\n    perspective: 240px;\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    border: 4px solid var(--primary);\n    background-size: 300% 300%;\n    transition: transform 0.3s;\n    transform: scale(var(--scale, 1)) translateZ(0);\n    -webkit-animation: var(--name, unchecked) var(--duration) ease forwards;\n            animation: var(--name, unchecked) var(--duration) ease forwards;\n    margin: 0;\n}\n.checkbox-wrapper .plus-minus::before,\n.checkbox-wrapper .plus-minus::after {\n    content: \"\";\n    position: absolute;\n    width: 16px;\n    height: var(--height, 16px);\n    left: 6px;\n    top: var(--top, 6px);\n    background: var(--background, var(--primary));\n    -webkit-animation: var(--name-icon-b, var(--name-icon, unchecked-icon)) var(--duration) ease forwards;\n            animation: var(--name-icon-b, var(--name-icon, unchecked-icon)) var(--duration) ease forwards;\n}\n.checkbox-wrapper .plus-minus::before {\n    -webkit-clip-path: polygon(0 6px, 6px 6px, 6px 0, 10px 0, 10px 6px, 16px 6px, 16px 10px, 10px 10px, 10px 16px, 6px 16px, 6px 10px, 0 10px);\n            clip-path: polygon(0 6px, 6px 6px, 6px 0, 10px 0, 10px 6px, 16px 6px, 16px 10px, 10px 10px, 10px 16px, 6px 16px, 6px 10px, 0 10px);\n}\n.checkbox-wrapper .plus-minus::after {\n    --height: 4px;\n    --top: 12px;\n    --background: var(--secondary);\n    --name-icon-b: var(--name-icon-a, checked-icon);\n}\n.checkbox-wrapper .plus-minus:active {\n    --scale: .95;\n}\n.checkbox-wrapper .plus-minus:checked {\n    --name: checked;\n    --name-icon-b: checked-icon;\n    --name-icon-a: unchecked-icon;\n}\n\n@-webkit-keyframes checked-icon {\n    from {\n    transform: translateZ(12px);\n    }\n    to {\n    transform: translateX(16px) rotateY(90deg) translateZ(12px);\n    }\n}\n@keyframes checked-icon {\n    from {\n    transform: translateZ(12px);\n    }\n    to {\n    transform: translateX(16px) rotateY(90deg) translateZ(12px);\n    }\n}\n\n@-webkit-keyframes unchecked-icon {\n    from {\n    transform: translateX(-16px) rotateY(-90deg) translateZ(12px);\n    }\n    to {\n    transform: translateZ(12px);\n    }\n}\n@keyframes unchecked-icon {\n    from {\n    transform: translateX(-16px) rotateY(-90deg) translateZ(12px);\n    }\n    to {\n    transform: translateZ(12px);\n    }\n}\n\n@-webkit-keyframes checked {\n    from {\n    background-image: radial-gradient(ellipse at center, var(--primary) 0%, var(--primary) 25%, var(--secondary) 25.1%, var(--secondary) 100%);\n    background-position: 100% 50%;\n    }\n    to {\n    background-image: radial-gradient(ellipse at center, var(--primary) 0%, var(--primary) 25%, var(--secondary) 25.1%, var(--secondary) 100%);\n    background-position: 50% 50%;\n    }\n}\n@keyframes checked {\n    from {\n    background-image: radial-gradient(ellipse at center, var(--primary) 0%, var(--primary) 25%, var(--secondary) 25.1%, var(--secondary) 100%);\n    background-position: 100% 50%;\n    }\n    to {\n    background-image: radial-gradient(ellipse at center, var(--primary) 0%, var(--primary) 25%, var(--secondary) 25.1%, var(--secondary) 100%);\n    background-position: 50% 50%;\n    }\n}\n\n@-webkit-keyframes unchecked {\n    from {\n    background-image: radial-gradient(ellipse at center, var(--secondary) 0%, var(--secondary) 25%, var(--primary) 25.1%, var(--primary) 100%);\n    background-position: 100% 50%;\n    }\n    to {\n    background-image: radial-gradient(ellipse at center, var(--secondary) 0%, var(--secondary) 25%, var(--primary) 25.1%, var(--primary) 100%);\n    background-position: 50% 50%;\n    }\n}\n@keyframes unchecked {\n    from {\n    background-image: radial-gradient(ellipse at center, var(--secondary) 0%, var(--secondary) 25%, var(--primary) 25.1%, var(--primary) 100%);\n    background-position: 100% 50%;\n    }\n    to {\n    background-image: radial-gradient(ellipse at center, var(--secondary) 0%, var(--secondary) 25%, var(--primary) 25.1%, var(--primary) 100%);\n    background-position: 50% 50%;\n    }\n}\n\n.black-background {\n    background-color: black !important;\n}\n\n.y-scrollable {\n    overflow-y: auto;\n}\n\n.height-100 {\n    height: 100%;\n}\n\n.huge-font {\n    font-size: 5rem;\n}\n\n.pos-tr {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n.pos-tc {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n}        \n\n.pos-tl {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.pos-br {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n\n.pos-bl {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n}\n\n.sticky {\n    position: sticky;\n    top: 0;\n    pointer-events: all;\n}\n\n.no-padding {\n    padding: 0 !important;\n}\n\n.is-relative {\n    position: relative !important;\n}\n\n.is-hidden {\n    display: none !important;\n}\n\n.is-clickable {\n    cursor: pointer;\n}\n\n.is-bold {\n    font-weight: bold;\n}\n\n.height-capped {\n    max-height: 25vh;\n    overflow-y: auto;\n}\n\n.height-capped::-webkit-scrollbar {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
